<template>
    <div>
        <Galleria v-if="galleryImages?.length" :value="galleryImages" :responsiveOptions="galleriaResponsiveOptions" :numVisible="2" :circular="true" containerStyle="max-width: 400px; margin: auto">
            <template #item="slotProps">
                <img :src="slotProps.item.vignette" :alt="slotProps.item.alt" style="width: 100%; display: block" />
            </template>
            <template #thumbnail="slotProps">
                <img :src="slotProps.item.thumbnail" :alt="slotProps.item.alt" tyle="width: 100%; display: block;" />
            </template>
            <template #caption="slotProps">
                <div class="text-xl mb-2 font-bold">{{ slotProps.item.original_name ?? slotProps.item.title }}</div>
            </template>
        </Galleria>
        <div v-else>No images available</div>
    </div>
</template>
<script setup>
import { ref, computed, defineProps } from 'vue';

const props = defineProps({
    attachments: {
        type: Array,
    },
});

const galleriaResponsiveOptions = ref([
    {
        breakpoint: '1024px',
        numVisible: 5,
    },
    {
        breakpoint: '960px',
        numVisible: 4,
    },
    {
        breakpoint: '768px',
        numVisible: 3,
    },
    {
        breakpoint: '560px',
        numVisible: 1,
    },
]);
const galleryImages = computed(() => {
    // separate out the file object
    const allFiles = props.attachments?.map((attachment) => attachment.file);
    // filter out files that is of image type
    const filteredResponse = allFiles?.filter((item) => item.mime_type?.startsWith('image/'));
    const images = filteredResponse?.map((item) => ({
        src: item.local_uri, // Use local_uri or s3_uri depending on your use case
        thumbnail: item.thumbnail,
        title: item.original_name,
        vignette: item.vignette,
    }));
    return images;
});
</script>
